<template>
  <main id="main">
    <!-- ======= Featured Services Section ======= -->
    <section id="featured-services" class="featured-services">
      <div class="container">
        <div class="row gy-4">
          <div class="col-lg-4 col-md-6 service-item d-flex" data-aos="fade-up">
            <div class="icon flex-shrink-0">
              <i class="fa-solid fa-cart-flatbed"></i>
            </div>
            <div>
              <h4 class="title">Сортировка товара</h4>
              <p class="description">
                Качественная и тщательная сортировка товаров.
              </p>
              <!-- <a href="service-details.html" class="readmore stretched-link"
                ><span>Learn More</span><i class="bi bi-arrow-right"></i
              ></a> -->
            </div>
          </div>
          <!-- End Service Item -->

          <div
            class="col-lg-4 col-md-6 service-item d-flex"
            data-aos="fade-up"
            data-aos-delay="100">
            <div class="icon flex-shrink-0">
              <i class="fa-solid fa-truck"></i>
            </div>
            <div>
              <h4 class="title">Отправка товара</h4>
              <p class="description">
                Быстрые дотавки товаров за 10 - 15 дней после отправки товаров.
              </p>
              <!-- <a href="service-details.html" class="readmore stretched-link"
                ><span>Learn More</span><i class="bi bi-arrow-right"></i
              ></a> -->
            </div>
          </div>
          <!-- End Service Item -->

          <div
            class="col-lg-4 col-md-6 service-item d-flex"
            data-aos="fade-up"
            data-aos-delay="200">
            <div class="icon flex-shrink-0">
              <i class="fa-solid fa-truck-ramp-box"></i>
            </div>
            <div>
              <h4 class="title">Доставка товара</h4>
              <p class="description">
                Ежедневная доставка по городу с отслеживанием статуса доставки
                своего заказа
              </p>
              <!-- <a href="service-details.html" class="readmore stretched-link"
                ><span>Learn More</span><i class="bi bi-arrow-right"></i
              ></a> -->
            </div>
          </div>
          <!-- End Service Item -->
        </div>
      </div>
    </section>
    <!-- End Featured Services Section -->

    <!-- ======= About Us Section ======= -->
    <section id="about" class="about pt-0">
      <div class="container" data-aos="fade-up">
        <div class="row gy-4">
          <div
            class="col-lg-4 position-relative align-self-start order-lg-last order-first">
            <img src="../../assets/img/video.png" class="img-fluid" alt="" />
            <a
              href="https://www.instagram.com/reel/C1waIIXMPsy/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
              class="glightbox play-btn"
              target="_blank"></a>
          </div>
          <div class="col-lg-8 content order-last order-lg-first">
            <h3>О нас</h3>
            <p>
              Golai.Express — ваш выбор №1 для экономичной грузоперевозки! Мы
              гордимся тем, что предлагаем самые доступные и выгодные тарифы,
              делая доставку ваших грузов по всему миру бюджетной и эффективной.
              Независимо от размера вашего бизнеса или объема перевозки,
              Golai.Express обеспечит вас самыми выгодными вариантами доставки.
              Наша команда стремится сделать международные перевозки максимально
              доступными, при этом поддерживая высокий уровень сервиса. Выберите
              Golai.Express для самой дешевой доставки и уверенности в том, что
              ваш груз будет доставлен надежно, оперативно и без лишних затрат.
              Ваш успех — наша цель, и мы делаем его доступным для вас с
              Golai.Express!
            </p>
            <ul>
              <li data-aos="fade-up" data-aos-delay="100">
                <i class="bi bi-diagram-3"></i>
                <div>
                  <h5>Клиентоориентированность</h5>
                  <p>В каждом действии - ваше удовлетворение!</p>
                </div>
              </li>
              <li data-aos="fade-up" data-aos-delay="200">
                <i class="bi bi-fullscreen-exit"></i>
                <div>
                  <h5>Короткие сроки</h5>
                  <p>Сроки сокращаем, результат оставляем высоким!</p>
                </div>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <i class="bi bi-broadcast"></i>
                <div>
                  <h5>Низкая цена</h5>
                  <p>
                    Низкая цена, высокое качество: ваш выбор без компромиссов!
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- End About Us Section -->

    <!-- ======= Services Section ======= -->
    <section id="service" class="services pt-0">
      <div class="container" data-aos="fade-up">
        <div class="section-header">
          <span>Наши услуги</span>
          <h2>Наши услуги</h2>
        </div>

        <div class="row gy-4">
          <div
            class="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="100">
            <div class="card">
              <div class="card-img">
                <img
                  src="../../assets/img/storage-service.jpg"
                  alt=""
                  class="img-fluid" />
              </div>
              <h3>
                <a href="service-details.html" class="stretched-link"
                  >Хранения товаров</a
                >
              </h3>
              <p>
                Качественное хранение товара обеспечивает надежность и
                безопасность всего процесса логистики, что является важным
                элементом для удовлетворения потребностей клиентов и успешного
                функционирования бизнеса.
              </p>
            </div>
          </div>
          <!-- End Card Item -->

          <!-- <div
            class="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="200">
            <div class="card">
              <div class="card-img">
                <img
                  src="../../assets/img/logistics-service.jpg"
                  alt=""
                  class="img-fluid" />
              </div>
              <h3>
                <a href="service-details.html" class="stretched-link"
                  >Logistics</a
                >
              </h3>
              <p>
                Asperiores provident dolor accusamus pariatur dolore nam id
                audantium ut et iure incidunt molestiae dolor ipsam ducimus
                occaecati nisi
              </p>
            </div>
          </div> -->
          <!-- End Card Item -->

          <!-- <div
            class="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="300">
            <div class="card">
              <div class="card-img">
                <img
                  src="../../assets/img/cargo-service.jpg"
                  alt=""
                  class="img-fluid" />
              </div>
              <h3>
                <a href="service-details.html" class="stretched-link">Cargo</a>
              </h3>
              <p>
                Dicta quam similique quia architecto eos nisi aut ratione aut
                ipsum reiciendis sit doloremque oluptatem aut et molestiae ut et
                nihil
              </p>
            </div>
          </div> -->
          <!-- End Card Item -->

          <div
            class="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="400">
            <div class="card">
              <div class="card-img">
                <img
                  src="../../assets/img/trucking-service.jpg"
                  alt=""
                  class="img-fluid" />
              </div>
              <h3>
                <a href="service-details.html" class="stretched-link"
                  >Трекинг товара</a
                >
              </h3>
              <p>
                Трекинг товара, или отслеживание товара, это процесс мониторинга
                перемещения товара от его отправления до доставки конечному
                получателю. Этот процесс обычно осуществляется с помощью
                специальных кодов трекинга (также известных как трек-коды или
                трек-номера), которые присваиваются каждой отправке.
              </p>
            </div>
          </div>
          <!-- End Card Item -->

          <div
            class="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="500">
            <div class="card">
              <div class="card-img">
                <img
                  src="../../assets/img/packaging-service.jpg"
                  alt=""
                  class="img-fluid" />
              </div>
              <h3>
                <a href="service-details.html" class="stretched-link"
                  >Сортировка товара</a
                >
              </h3>
              <p>
                Качественная упаковка товара не только обеспечивает его
                сохранность во время транспортировки, но также создает
                впечатление о профессионализме и заботе со стороны производителя
                или продавца.
              </p>
            </div>
          </div>
          <!-- End Card Item -->

          <!-- <div
            class="col-lg-4 col-md-6"
            data-aos="fade-up"
            data-aos-delay="600">
            <div class="card">
              <div class="card-img">
                <img
                  src="../../assets/img/warehousing-service.jpg"
                  alt=""
                  class="img-fluid" />
              </div>
              <h3>
                <a href="service-details.html" class="stretched-link"
                  >Warehousing</a
                >
              </h3>
              <p>
                Quas assumenda non occaecati molestiae. In aut earum sed natus
                eatae in vero. Ab modi quisquam aut nostrum unde et qui est non
                quo nulla
              </p>
            </div>
          </div> -->
          <!-- End Card Item -->
        </div>
      </div>
    </section>
    <!-- End Services Section -->

    <!-- ======= Call To Action Section ======= -->
    <section id="call-to-action" class="call-to-action">
      <div class="container" data-aos="zoom-out">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <h3>Присоединитесь к нам</h3>
            <p>
              Присоединяйтесь к нашей компании и получите свой уникальный код
              клиента! Ваш индивидуальный код клиента позволит вам получить
              доступ к эксклюзивным предложениям, специальным акциям и
              персонализированному обслуживанию. Воспользуйтесь им при
              оформлении заказов или обращении к нашей службе поддержки, чтобы
              мы могли обеспечить вас лучшими условиями и сервисом.
              Присоединяйтесь прямо сейчас и начните получать преимущества быть
              частью нашей команды!
            </p>
            <a class="cta-btn" href="#" @click.prevent="$emit('getCode')"
              >Получить код</a
            >
          </div>
        </div>
      </div>
    </section>
    <!-- End Call To Action Section -->

    <!-- ======= Features Section ======= -->
    <section id="features" class="features">
      <div class="container">
        <div
          class="row gy-4 align-items-center features-item"
          data-aos="fade-up">
          <div class="col-md-5">
            <img
              src="../../assets/img/features-1.jpg"
              class="img-fluid"
              alt="" />
          </div>
          <div class="col-md-7">
            <h3>Упаковка товара</h3>
            <p class="fst-italic">
              Качественная упаковка товара играет ключевую роль в защите товара
              от повреждений во время транспортировки и представляет важный
              аспект в создании положительного впечатления у клиентов. Она
              включает в себя следующие элементы:
            </p>
            <ul>
              <li>
                <i class="bi bi-check"></i> Использование высококачественных и
                прочных материалов, таких как картона или пленки, обеспечивает
                надежную защиту товара от ударов и внешних воздействий.
              </li>
              <li>
                <i class="bi bi-check"></i> Упаковка должна быть подобрана таким
                образом, чтобы соответствовать размерам и форме товара,
                предотвращая его смещение и повреждения внутри упаковки.
              </li>
              <li>
                <i class="bi bi-check"></i> Использование дополнительных
                элементов защиты, таких как пузырчатая пленка, пенопластовые
                вставки или защитные уголки, помогает предотвратить повреждения
                товара в случае ударов или падений.
              </li>
              <li>
                <i class="bi bi-check"></i> Помимо защитных функций, упаковка
                должна содержать информационные метки с данными о товаре,
                инструкциями по обращению и другой необходимой информацией для
                клиентов.
              </li>
            </ul>
          </div>
        </div>
        <!-- Features Item -->

        <div
          class="row gy-4 align-items-center features-item"
          data-aos="fade-up">
          <div class="col-md-5 order-1 order-md-2">
            <img
              src="../../assets/img/features-2.jpg"
              class="img-fluid"
              alt="" />
          </div>
          <div class="col-md-7 order-2 order-md-1">
            <h3>Трекинг товара</h3>
            <p class="fst-italic">
              Трекинг товара, или отслеживание товара, это процесс мониторинга
              перемещения товара от его отправления до доставки конечному
              получателю. Этот процесс обычно осуществляется с помощью
              специальных кодов трекинга (также известных как трек-коды или
              трек-номера), которые присваиваются каждой отправке.
            </p>
            <ul>
              <li>
                <i class="bi bi-check"></i>Покупатели могут отслеживать статус
                своего заказа и быть в курсе его местоположения в реальном
                времени. Это создает прозрачность и доверие между продавцом и
                покупателем.
              </li>
              <li>
                <i class="bi bi-check"></i>Отслеживание товаров позволяет быстро
                обнаруживать потери или утери грузов и принимать меры по их
                решению.
              </li>
              <li>
                <i class="bi bi-check"></i> Предоставление возможности
                отслеживания заказа повышает уровень обслуживания клиентов, так
                как они могут получать информацию о статусе своего заказа в
                режиме реального времени.
              </li>
            </ul>
          </div>
        </div>
        <!-- Features Item -->

        <div
          class="row gy-4 align-items-center features-item"
          data-aos="fade-up">
          <div class="col-md-5">
            <img
              src="../../assets/img/features-3.jpg"
              class="img-fluid"
              alt="" />
          </div>
          <div class="col-md-7">
            <h3>Доставка товаров по городу</h3>
            <p>
              Доставка товаров по городу – это процесс доставки заказанных
              товаров клиентам в пределах городских территорий. Вот краткое
              описание основных этапов и характеристик этого процесса:
            </p>
            <ul>
              <li>
                <i class="bi bi-check"></i> После получения заказа сотрудники
                компании собирают необходимые товары, упаковывают их и готовят к
                отправке.
              </li>
              <li>
                <i class="bi bi-check"></i> Оптимизация маршрутов доставки
                позволяет эффективно использовать время и ресурсы, минимизируя
                время в пути и расходы на транспорт.
              </li>
              <li>
                <i class="bi bi-check"></i> Товары доставляются непосредственно
                к месту назначения – дому клиента, офису или пункту самовывоза,
                в соответствии с выбранным клиентом способом доставки.
              </li>
              <li>
                <i class="bi bi-check"></i> Перед доставкой клиенту отправляется
                уведомление с информацией о времени прибытия курьера или о
                возможности самостоятельного получения товара.
              </li>
              <li>
                <i class="bi bi-check"></i> Клиенты могут отслеживать статус
                доставки своего заказа через онлайн-сервисы или приложения, что
                обеспечивает прозрачность и уверенность в получении товара
                вовремя.
              </li>
              <li>
                <i class="bi bi-check"></i> В случае вопросов или проблем с
                доставкой клиенты могут обратиться в службу поддержки для
                получения помощи и решения возникших вопросов.
              </li>
            </ul>
          </div>
        </div>
        <!-- Features Item -->

        <!-- <div
          class="row gy-4 align-items-center features-item"
          data-aos="fade-up">
          <div class="col-md-5 order-1 order-md-2">
            <img
              src="../../assets/img/features-4.jpg"
              class="img-fluid"
              alt="" />
          </div>
          <div class="col-md-7 order-2 order-md-1">
            <h3>
              Quas et necessitatibus eaque impedit ipsum animi consequatur
              incidunt in
            </h3>
            <p class="fst-italic">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <p>
              Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
              irure dolor in reprehenderit in voluptate velit esse cillum dolore
              eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
              proident, sunt in culpa qui officia deserunt mollit anim id est
              laborum
            </p>
          </div>
        </div> -->
        <!-- Features Item -->
      </div>
    </section>
    <!-- End Features Section -->

    <!-- <section id="pricing" class="pricing pt-0">
      <div class="container" data-aos="fade-up">
        <div class="section-header">
          <span>Pricing</span>
          <h2>Pricing</h2>
        </div>
        <div class="row gy-4">
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
            <div class="pricing-item">
              <h3>Free Plan</h3>
              <h4><sup>$</sup>0<span> / month</span></h4>
              <ul>
                <li><i class="bi bi-check"></i> Quam adipiscing vitae proin</li>
                <li><i class="bi bi-check"></i> Nec feugiat nisl pretium</li>
                <li>
                  <i class="bi bi-check"></i> Nulla at volutpat diam uteera
                </li>
                <li class="na">
                  <i class="bi bi-x"></i>
                  <span>Pharetra massa massa ultricies</span>
                </li>
                <li class="na">
                  <i class="bi bi-x"></i>
                  <span>Massa ultricies mi quis hendrerit</span>
                </li>
              </ul>
              <a href="#" class="buy-btn">Buy Now</a>
            </div>
          </div>
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
            <div class="pricing-item featured">
              <h3>Business Plan</h3>
              <h4><sup>$</sup>29<span> / month</span></h4>
              <ul>
                <li><i class="bi bi-check"></i> Quam adipiscing vitae proin</li>
                <li><i class="bi bi-check"></i> Nec feugiat nisl pretium</li>
                <li>
                  <i class="bi bi-check"></i> Nulla at volutpat diam uteera
                </li>
                <li>
                  <i class="bi bi-check"></i> Pharetra massa massa ultricies
                </li>
                <li>
                  <i class="bi bi-check"></i> Massa ultricies mi quis hendrerit
                </li>
              </ul>
              <a href="#" class="buy-btn">Buy Now</a>
            </div>
          </div>
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
            <div class="pricing-item">
              <h3>Developer Plan</h3>
              <h4><sup>$</sup>49<span> / month</span></h4>
              <ul>
                <li><i class="bi bi-check"></i> Quam adipiscing vitae proin</li>
                <li><i class="bi bi-check"></i> Nec feugiat nisl pretium</li>
                <li>
                  <i class="bi bi-check"></i> Nulla at volutpat diam uteera
                </li>
                <li>
                  <i class="bi bi-check"></i> Pharetra massa massa ultricies
                </li>
                <li>
                  <i class="bi bi-check"></i> Massa ultricies mi quis hendrerit
                </li>
              </ul>
              <a href="#" class="buy-btn">Buy Now</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- ======= Testimonials Section ======= -->
    <section id="testimonials" class="testimonials">
      <div class="container">
        <div class="slides-1 swiper" data-aos="fade-up">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="testimonial-item">
                <img
                  src="../../assets/img/isanov.png"
                  class="testimonial-img"
                  alt="" />
                <h3>Исанов Дөөлөтбек</h3>
                <h4>Ceo &amp; Founder</h4>
                <div class="stars">
                  <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i
                  ><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i
                  ><i class="bi bi-star-fill"></i>
                </div>
                <p>
                  <i class="bi bi-quote quote-icon-left"></i>
                  Golai.Express: Доставка с экономичным взглядом на будущее.
                  Безграничная доступность по самым выгодным ценам!
                  <i class="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </div>
            <!-- End testimonial item -->
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </section>
    <!-- End Testimonials Section -->

    <!-- End Testimonials Section -->

    <!-- ======= Frequently Asked Questions Section ======= -->
    <section id="faq" class="faq">
      <div class="container" data-aos="fade-up">
        <div class="section-header">
          <span>Часто задаваемые вопросы</span>
          <h2>Часто задаваемые вопросы</h2>
        </div>

        <div
          class="row justify-content-center"
          data-aos="fade-up"
          data-aos-delay="200">
          <div class="col-lg-10">
            <div class="accordion accordion-flush" id="faqlist">
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-5">
                    <i class="bi bi-question-circle question-icon"></i>
                    Какая цена за кг?
                  </button>
                </h3>
                <div
                  id="faq-content-5"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    У нас самая низкая цена по Кыргызстану. Цена за кг 3.3$.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-1">
                    <i class="bi bi-question-circle question-icon"></i>
                    Как отслеживать наши товары?
                  </button>
                </h3>
                <div
                  id="faq-content-1"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Путь от магазина до нашего склада в Китае вы отслеживаете в
                    самом приложении где вы заказываете, там есть грузовичок он
                    показывает где едет ваш товар. После того как ваш товар
                    поступил на наш склад в Китае вы должны будете отслеживать
                    ваш товар уже нашем сайте Golai express
                  </div>
                </div>
              </div>
              <!-- # Faq item-->

              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-2">
                    <i class="bi bi-question-circle question-icon"></i>
                    Срок доставки?
                  </button>
                </h3>
                <div
                  id="faq-content-2"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Срок доставки после поступления вашего товара на наш склад в
                    Китае за 15-20 дней поступают товары
                  </div>
                </div>
              </div>
              <!-- # Faq item-->

              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-3">
                    <i class="bi bi-question-circle question-icon"></i>
                    А можно ли купленный товар если уже получили возврат
                    сделать?
                  </button>
                </h3>
                <div
                  id="faq-content-3"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Купленный товар возврату не подлежит.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->

              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-4">
                    <i class="bi bi-question-circle question-icon"></i>
                    А можно ли заказывать мобильный телефон?
                  </button>
                </h3>
                <div
                  id="faq-content-4"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    <i class="bi bi-question-circle question-icon"></i>
                    Нельзя, мобильный телефон входит список запрещенных товаров
                  </div>
                </div>
              </div>
              <!-- # Faq item-->

              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-5">
                    <i class="bi bi-question-circle question-icon"></i>
                    Что такое обрещетка?
                  </button>
                </h3>
                <div
                  id="faq-content-5"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Обрешетка - это защитный каркас из определенного материала,
                    который используется для перевозки ценных и хрупких грузов.
                    Также за обрещетку взимается плата и вес товара считается
                    вместе с обрещеткой.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-6">
                    <i class="bi bi-question-circle question-icon"></i>
                    Что такое трек код?
                  </button>
                </h3>
                <div
                  id="faq-content-6"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Трек-номер - это уникальный номер для отслеживания посылки,
                    который выдает транспортная компания.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-7">
                    <i class="bi bi-question-circle question-icon"></i>
                    Как узнать что наш товар поступил в Кыргызстан?
                  </button>
                </h3>
                <div
                  id="faq-content-7"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Заходим на сайт, там в разделе «на складе» будут отображены
                    все товары которые у нас на складе в Бишкеке.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-8">
                    <i class="bi bi-question-circle question-icon"></i>
                    Если товар потеряется кто будет нести ответственность ?
                  </button>
                </h3>
                <div
                  id="faq-content-8"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Если ваш товар был доставлен до нашего склада и был в
                    отправках , но он не поступил на наш склад в Кыргызстане, то
                    ответственность несем мы.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-9">
                    <i class="bi bi-question-circle question-icon"></i>
                    Можно ли заказывать люстры?
                  </button>
                </h3>
                <div
                  id="faq-content-9"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Хрупкие товары можно заказывать в том случае если попросить
                    продавца хорошо упаковать товар и отметить что это хрупкий
                    товар. И если клиент все еще переживает насчет посылки, то
                    должен заранее предупредить менеджеров чтобы на складе в
                    Китае сделали обрешётку для этого хрупкого товара.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-10">
                    <i class="bi bi-question-circle question-icon"></i>
                    Вес округляете?
                  </button>
                </h3>
                <div
                  id="faq-content-10"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Самый маленький вес 100 грамм, округляется только в том
                    случае если товар весит ниже 100 граммов, а все остальное
                    нет , то есть, 1 кг 300 грамм.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
              <div class="accordion-item">
                <h3 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq-content-11">
                    <i class="bi bi-question-circle question-icon"></i>
                    Сколько хранится товар на вашем складе ?
                  </button>
                </h3>
                <div
                  id="faq-content-11"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faqlist">
                  <div class="accordion-body">
                    Товар хранится 10 дней бесплатно, а после по 4,5$ , на 3
                    месяц будет ликвидация товара.
                  </div>
                </div>
              </div>
              <!-- # Faq item-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Frequently Asked Questions Section -->
  </main>
  <!-- End #main -->
</template>
<script>
export default {
  name: "MainContent",
};
</script>

<!-- <style scoped>
@import "../../styles/css/bootstrap.min.css";
</style> -->
